import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-op-blend",
  "use": "icon-op-blend-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-op-blend\"><path d=\"M6.5 6C8.4 6 10 7.6 10 9.5S8.4 13 6.5 13 3 11.4 3 9.5 4.6 6 6.5 6m0-1C4 5 2 7 2 9.5S4 14 6.5 14 11 12 11 9.5 9 5 6.5 5\" /><path d=\"M9.5 3C11.4 3 13 4.6 13 6.5S11.4 10 9.5 10 6 8.4 6 6.5 7.6 3 9.5 3m0-1C7 2 5 4 5 6.5S7 11 9.5 11 14 9 14 6.5 12 2 9.5 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol